import { useEffect, useState } from "react"
import { IMyFood } from "model/food/types/myfood.types"
import {
  getNutritionFromIngredients,
  updateIngredientsWhenPortionChange,
} from "../../helper/myFoodForm"
import { updateManualNutritionMealWhenPortionChange } from "features/food/helper/edamaForm"

const useMyFoodDetailsForm = <T extends IMyFood>(initFood?: T) => {
  const [myFood, setMyFood] = useState(initFood)

  useEffect(() => {
    if (initFood) {
      setMyFood(initFood)
    }
  }, [initFood])

  const onPortionChange = (portion: number) => {
    setMyFood((prevFood) => {
      if (!prevFood) return prevFood

      const ingredients = updateIngredientsWhenPortionChange({
        ingredients: prevFood.ingredients,
        portion: prevFood.portion,
        nextPortion: portion,
      })

      const nutrition = prevFood.isManualNutrition
        ? updateManualNutritionMealWhenPortionChange(prevFood, portion)
        : getNutritionFromIngredients(ingredients)

      return { ...prevFood, ...nutrition, ingredients, portion }
    })
  }

  const onUnitChange = (unitLabel: string) => {
    setMyFood((prev) => (prev ? { ...prev, unit: unitLabel } : prev))
  }

  const updateFoodAsManualNutrition = ({
    gram,
    ...nutrition
  }: Partial<IMyFood>) => {
    if (myFood) {
      setMyFood({ ...myFood, ...nutrition, isManualNutrition: true })
    }
  }

  return {
    myFood,
    onPortionChange,
    onUnitChange,
    updateFoodAsManualNutrition,
  }
}

export default useMyFoodDetailsForm
